import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import Table, {
  TableCellWithMonoSpaceFonts,
  TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@fuww/library/src/Table';
import IntelligencePageLayout
  from '@fuww/library/src/Layouts/IntelligencePage';
import SpacingContainer from '@fuww/library/src/SpacingContainer';
import Layout from '../components/Layout';
import Head from '../components/Head';
import Hero from '../components/Hero';
import messages from '../lib/messages.mjs';
import mostValuableFashionBrands
  from '../data/staticPages/i/most-valuable-fashion-brands.json';
import formatBigMoney from '../lib/formatBigMoney';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';

const headerImageUrls = {
  mobile: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=34,quality=10,width=42/https://media.fashionunited.com/media/images/most-valuable-fashion-brands-mobile.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=288,quality=70,width=360/https://media.fashionunited.com/media/images/most-valuable-fashion-brands-mobile.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=576,quality=70,width=720/https://media.fashionunited.com/media/images/most-valuable-fashion-brands-mobile.jpg',
  ],
  desktop: [
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=8,quality=10,width=42/https://media.fashionunited.com/media/images/most-valuable-fashion-brands.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=277,quality=70,width=1350/https://media.fashionunited.com/media/images/most-valuable-fashion-brands.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=526,quality=70,width=2560/https://media.fashionunited.com/media/images/most-valuable-fashion-brands.jpg',
    'https://fashionunited.com/r/fit=cover,format=auto,gravity=center,height=1052,quality=70,width=5120/https://media.fashionunited.com/media/images/most-valuable-fashion-brands.jpg',
  ],
};

const MostValuableFashionBrandsPage = () => {
  const intl = useIntl();

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'most-valuable-fashion-brands',
    'mostValuableFashionBrands',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(messages['mostValuableFashionBrands.title'])}
        description={intl.formatMessage(
          messages['mostValuableFashionBrands.description'],
        )}
      />
      <IntelligencePageLayout
        description={
          intl.formatMessage(
            messages['mostValuableFashionBrands.description'],
          )
        }
        content={(
          <>
            <TableContainer>
              <Table aria-label={intl.formatMessage(
                messages[
                  'mostValuableFashionBrands.table.ariaLabel'],
              )}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>
                      #
                    </TableCell>
                    <TableCell>
                      {intl.formatMessage(
                        messages.name,
                      )}
                    </TableCell>
                    <TableCell align="right">
                      {intl.formatMessage(
                        messages.brandValue,
                      )}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {mostValuableFashionBrands.map(({
                    brand,
                    brandValue,
                  }, index) => (
                    <TableRow key={brand}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{brand}</TableCell>
                      <TableCellWithMonoSpaceFonts align="right">
                        {formatBigMoney(brandValue)}
                      </TableCellWithMonoSpaceFonts>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <SpacingContainer />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages[
                'mostValuableFashionBrands.footer'
              ]),
            }}
            />
            <SpacingContainer />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages[
                'mostValuableFashionBrands.disclaimer'
              ]),
            }}
            />
            <SpacingContainer />
            <div>
              {intl.formatMessage(messages.copyright)}
            </div>
          </>
        )}
        breadcrumbs={breadcrumbs}
        subTitle={intl.formatMessage(
          messages['mostValuableFashionBrands.subTitle'],
        )}
        title={intl.formatMessage(messages['mostValuableFashionBrands.title'])}
      />
    </>
  );
};

MostValuableFashionBrandsPage.getLayout = (page: ReactElement) => (
  <Layout header={
    <Hero alt="Most Valuable Fashion Brands" imageUrls={headerImageUrls} />
    }
  >
    {page}
  </Layout>
);

MostValuableFashionBrandsPage.getInitialProps = redirectRouteToDomain(
  'most-valuable-fashion-brands',
);

export default MostValuableFashionBrandsPage;
